const CONFIGURATOR_TITLE = 'Low Code Configurator';
const inputLimit = 'Input limit - 100 characters.';
export class AppConstants {
  public static categoryname = 'REFERRAL_ATTACHMENTS';
  public static changePasswordText = 'text';
  public static changePasswordPassword = 'password';
  public static regexEmail = '^[0-9a-zA-Z.-]+[@][0-9a-zA-Z.-]+[.][0-9a-zA-Z]{2,}$';
  public static regexPhone = '^[2-9][0-9]{2}-[2-9][0-9]{2}-[0-9]{4}$';
  public static regexName = '^[a-zA-Z]{2,}$';
  public static regexZipcode = '^[3][0-9]{4}$';
  public static regexSsn = '^(?!666|000|9\\d{2})\\d{3}-(?!00)\\d{2}-(?!0{4})\\d{4}$';
  public static regexSsnDigits = /^(\d{3}-?\d{2}-?\d{4}|XXX-XX-XXXX)$/;
  public static regexForPhone = '/^[()s-]*(d{8,12}|d{3}[)s-]*d{3}[s-]*d{4}|d{10})[()s-]*$/';
  public static formatDate = 'MM/DD/YYYY';
  public static camalize = '/[^a-zA-Z0-9]+(.)/g';
  public static checSchemaExistQuery = '/(?<=(as|AS)s)("*[a-zA-Zs#~_]*"*)(?=,|(from|FROM))/g';
  public static URLVALIDATE = '/(ftp|http|https)://(w+:{0,1}w*@)?(S+)(:[0-9]+)?(/|/([w#!:.?+=&%@!-/]))?/';
  public static EventURLValidate: '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  public static RegexUrlConstant =
    '/^(([^<>()[]\\.,;:s@"]+(.[^<>()[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/';
  public static statusComments = '/<[^>]*>/g';
  public static regexEmailType2 = '^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$';
  public static regexssnNumber = /^\d{3}-\d{2}-\d{4}$/;
  public static regexeinNumber = /^\d{2}-\d{7}$/;
  public static regexnpiNumber = /^\d{10}$/;
  public static regexfederalTaxNumber = /^\d{3}-\d{2}-\d{4}$/;
  public static regexzipCode = /^\d{5}(-\d{4})?$/;
  public static errorMessage = 'Something went wrong!';
  public static accessDeniedMessage = 'Access Denied';
  public static sessionExpired = 'Your session is expired.';
  public static providerError = 'Unable to Process the Request Contact support';
  public static verificationSuccess = 'Verification code sent successfully';
  public static emailVerificationSuccess = 'Link sent successfully. Please check your inbox for further instructions';
  public static passwordNotMatch = 'Password does not match';
  public static vaildEmail = 'Please enter a valid email';
  public static requiredFields = 'Please fill all required fields!';
  public static pleaseSelectAnOption = 'Please select an option';
  public static cloudProviderError = 'Missing Cloud Provider';
  public static verificationLocked = 'For your security, verification has been temporarily locked due to multiple incorrect code entries. You can try again in {minutes} minutes.';
  public static incorrectAttempt = 'The code entered is incorrect. You have {remainingAttempts} attempt(s) remaining before verification is temporarily locked.';
  public static readonly PAGES = [
    { page: 'admin', title: 'User Management' },
    { page: 'intake-worker', title: 'Dashboard' },
    { page: 'microstrategy', title: 'Analytics' },
    { page: 'form-builder', title: CONFIGURATOR_TITLE },
    { page: 'tab-order', title: CONFIGURATOR_TITLE },
    { page: 'workflow', title: CONFIGURATOR_TITLE },
    { page: 'document-packetization', title: 'Document Packetization' },
    { page: 'email-template', title: 'Email Template' },
    { page: 'chat', title: 'Chat' },
    { page: 'help-desk', title: 'Help' },
    { page: 'ocr-validation', title: 'Referrals' },
    { page: 'event-scheduler', title: 'Event Scheduler' },
    { page: 'config-dashboard', title: 'Config Dashboard' },
    { page: 'config-dashboard-user', title: 'Config Dashboard User' },
    { page: 'forms', title: 'Forms ' },
    { page: 'page-design', title: 'Page Design' },
    { page: 'dashboard-design', title: 'Dashboard Design' },
    { page: 'main-notification', title: 'Notification' },
    { page: 'dynamicPages', title: '' },
    { page: 'profile', title: 'Profile' }
  ];

  public static errorList = [
    'Have at least one (1) number',
    'Have at least one (1) special character',
    'Have at least one (1) upper case letter',
    'Have at least one (1) lower case letter',
    'Contain a minimum of eight (8) characters'
  ];

  public static referralSource = [
    { value: 'law enforcement', label: 'Law Enforcement' },
    { value: 'citizen complaint', label: 'Citizen Complaint' }
  ];

  public static generateNumber(): any {
    const crypto = window.crypto;
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    return array[0];
  }

  public static iconList = [
    { label: 'Apps', value: 'apps' },
    { label: 'Admin Settings', value: 'admin_panel_settings' },
    { label: 'Description', value: 'description' },
    { label: 'Analytics', value: 'analytics' },
    { label: 'Settings', value: 'settings' },
    { label: 'Library', value: 'library_books' },
    { label: 'Long Receipt', value: 'receipt_long' },
    { label: 'List', value: 'list' },
    { label: 'Layers', value: 'layers' },
    { label: 'Summarize', value: 'summarize' },
    { label: 'Featured List', value: 'featured_play_list' },
    { label: 'Contract', value: 'contract' },
    { label: 'List Add', value: 'list_alt_add' },
    { label: 'Inactive Order', value: 'inactive_order' },
    { label: 'Receipt', value: 'receipt' },
    { label: 'Dataset', value: 'dataset' },
    { label: 'Density', value: 'density_medium' },
    { label: 'Data Thresholding', value: 'data_thresholding' },
    { label: 'View Comfy', value: 'view_comfy_alt' },
    { label: 'View Compact', value: 'view_compact_alt' },
    { label: 'Rebase', value: 'rebase' },
    { label: 'Data Check', value: 'data_check' },
    { label: 'Check', value: 'check' },
    { label: 'Right Panel Close', value: 'right_panel_close' },
    { label: 'Toolbar', value: 'toolbar' },
    { label: 'User List', value: 'patient_list' },
    { label: 'Tabs', value: 'tabs' },
    { label: 'Single Tab', value: 'tab' },
    { label: 'Shelf Position', value: 'shelf_position' },
    { label: 'Call', value: 'call' },
    { label: 'Bookmark', value: 'bookmark' },
    { label: 'Map', value: 'map' },
    { label: 'Book', value: 'book' },
    { label: 'Box', value: 'box' },
    { label: 'Lock', value: 'lock' },
    { label: 'Star', value: 'star' },
    { label: 'Menu', value: 'menu' },
    { label: 'School', value: 'school' },
    { label: 'Calendar', value: 'calendar_month' },
    { label: 'Circle', value: 'circle' },
    { label: 'Home', value: 'home' },
    { label: 'Bulleted List', value: 'format_list_bulleted' },
    { label: 'Database', value: 'database' },
    { label: 'View Timeline', value: 'view_timeline' },
    { label: 'Settings Account Box', value: 'settings_account_box' },
    { label: 'Iframe', value: 'iframe' },
    { label: 'Bottom Panel Close', value: 'bottom_panel_close' },
    { label: 'Bubbles', value: 'bubbles' },
    { label: 'Task', value: 'task' },
    { label: 'Quiz', value: 'quiz' },
    { label: 'Contact Mail', value: 'contact_mail' },
    { label: 'File Copy', value: 'file_copy' },
    { label: 'Post Add', value: 'post_add' },
    { label: 'Import Contacts', value: 'import_contacts' },
    { label: 'Pending Actions', value: 'pending_actions' },
    { label: 'History Edu', value: 'history_edu' },
    { label: 'Space Dashboard', value: 'space_dashboard' },
    { label: 'Dashboard', value: 'dashboard' },
    { label: 'Table Chart', value: 'table_chart' },
    { label: 'Edit Document', value: 'edit_document' }
  ];
  public static defaultVariables = [
    { name: 'User_Name' },
    { name: 'Email_Id' },
    { name: 'Referral_Id' },
    { name: 'Attachment_Details' }
  ];
  public static userTimeOut = 31;
  public static userPing = 120;
  public static readonly headerLogoPath = '/assets/images/NDE-logo_text.svg';
  public static readonly minimizedHeaderLogoPath = '/assets/images/NDE-logo-without-text.svg';
  public static onInput(event: any, fieldtype: any, label: any, required: boolean) {
    const validationConfig = [
      {
        type: 'username',
        pattern: {
          regex: /^[a-zA-ZÀ-ÖØ-öø-ÿ][a-zA-ZÀ-ÖØ-öø-ÿ' -]*$/,
          errormessage: 'Allowed input - Alphabetic, accented letters, apostrophe, and hyphens.',
          errormessage2: 'First character should be Alphabetic or accented letters.'
        },
        length: { maxlength: '100', errormessage: inputLimit }
      },
      {
        type: 'description',
        length: { maxlength: '500', errormessage: 'Input limit - 500 characters.' }
      },
      {
        type: 'name',
        pattern: {
          regex: /^[a-zA-Z0-9-_ ]+$/,
          errormessage: 'Allowed input - Alphanumeric, hyphen, underscore, and space.'
        },
        length: { maxlength: '100', errormessage: inputLimit }
      },
      {
        type: 'email',
        pattern: {
          regex: /^\w+(?:[.+]\w+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          errormessage: 'Valid Email ID is Required'
        },
        length: { maxlength: '200', errormessage: 'Input limit - 200 characters.' }
      },
      {
        type: 'alphanumericandhyphensonly',
        pattern: { regex: /^[a-zA-Z0-9-]+$/, errormessage: 'Allowed input - Alphanumeric, hyphen.' },
        length: { maxlength: '100', errormessage: inputLimit }
      }
    ];

    const config = validationConfig.find(item => item.type === fieldtype);
    const value = (event.target as HTMLInputElement).value.trim();

    if (value && config) {
      const patternError = validatePattern(config, value, fieldtype);
      if (patternError) {
        return patternError;
      }

      const lengthError = validateLength(config, value, label);
      if (lengthError) {
        return lengthError;
      }
    } else if (!value && required) {
      return `${label} is Required`;
    }

    return null;
  }
}

function validatePattern(config: any, value: string, fieldtype: string): string | null {
  if (config.pattern) {
    const pattern = new RegExp(config.pattern.regex);
    if (fieldtype === 'username') {
      const firstLetterValid = /^[a-zA-ZÀ-ÖØ-öø-ÿ]/.test(value.charAt(0));
      if (!firstLetterValid) {
        return config.pattern.errormessage2;
      }
    }
    const patternValid = pattern.test(value);
    if (!patternValid) {
      return config.pattern.errormessage;
    }
  }
  return null;
}

function validateLength(config: any, value: string, label: string): string | null {
  const maxLength = parseInt(config.length.maxlength, 10);
  if (value.length > maxLength) {
    return `${label} ${config.length.errormessage}`;
  }
  return null;
}
